import { ActionEnum } from "src/app/_enum/rule/action.enum";
import { TriggerEnum } from "src/app/_enum/rule/trigger.enum";
import { arraysEqual, isArray } from "../../_helper/util.helper";
import { BaseModel } from "../base.model";
import { KeyValueInterface } from "../form/interface/key-value.interface";
import { PropertyModel } from "../property/property.model";
import { UserModel } from "../member/user.model";
import { LookupModel } from "../metadata/lookup.model";

/**
 * A base Rule model that contains the most essential rule data to be saved.
 */
export class RuleModel extends BaseModel {

  public from: string | string[] = null;
  public to: string = null;
  public trigger: TriggerEnum = null;
  public tValue: any = null;
  public action: ActionEnum = null;
  public aValue: any = null;
  public constraints: { field: string, value: string[], values?: KeyValueInterface<LookupModel>[] }[] = [];
  public roles: string[] = [];
  public ruleDate: string = null;
  public createDate: string = null;

  constructor(model?: Partial<RuleModel>) {
    super();
    this.overwrite(model);
    if (typeof this.tValue == 'string' && this.tValue?.startsWith('"') && this.tValue.endsWith('"')) {
      this.tValue = this.tValue.substring(1, this.tValue.length - 1);
    }
    if (typeof this.aValue == 'string' && this.aValue?.startsWith('"') && this.aValue.endsWith('"')) {
      this.aValue = this.aValue.substring(1, this.aValue.length - 1);
    }
    this.constraints = this.constraints.filter(c => c.field && c.value && c.value.length);
  }

  /**
   * Returns a boolean indicating whether a rule is triggered by a specific mapping (input).
   * Necessary because it can potentially be from multiple inputs at once.
   */
  public isFrom(mapping: string | string[]): boolean {
    if (isArray(mapping)) return isArray(this.from) ? arraysEqual(<string[]>this.from, <string[]>mapping) : mapping.includes(<string>this.from);
    return isArray(this.from) ? this.from.includes(<string>mapping) : this.from === mapping;
  }

  /**
   * Indicates whther the rule is triggered by multiple inputs (true) or a single input (false)
   */
  public isFromMultiple(): boolean {
    return isArray(this.from);
  }

  /**
   * Checks the constraints on a rule (if applicable) against the data on a listing.
   * If the constraints are found in the data, the rule can potentially trigger.
   */
  public constraintsValid(listing: PropertyModel): boolean {
    for (let constraint of this.constraints) {
      if (constraint.value.length && !constraint.value.includes(listing[constraint.field])) {
        return false;
      }
    }
    return true;
  }

  public rolesValid(user: UserModel): boolean {
    if (!this.roles.length) return true;
    for (let role of this.roles) {
      if (user?.memberRoles?.find(r => r.roleName === role)) {
        return true;
      }
    }
    return false;
  }

  public datesValid(listing: PropertyModel): boolean {
    if (this.ruleDate) {
      let ruleDate = new Date(this.ruleDate);
      ruleDate.setHours(0, ruleDate.getTimezoneOffset(), 0, 0);
      if (ruleDate.getTime() < new Date().getTime()) return false;
    }
    if (this.createDate && listing.CreateDate) {
      let createDate = new Date(this.createDate);
      createDate.setHours(0, createDate.getTimezoneOffset(), 0, 0);
      let listingCreateDate = new Date(listing.CreateDate.includes('T') ? listing.CreateDate.split('T')[0] : listing.CreateDate);
      listingCreateDate.setHours(0, listingCreateDate.getTimezoneOffset(), 0, 0);
      if (listingCreateDate.getTime() < createDate.getTime()) return false;
    }
    return true;
  }
}
